import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setStatFilters, resetStatFilters } from '../../action/statistics';
import { fetchPopularGoods, fetchOrderGoods } from '../../action/ordergoods';
import { fetchCities } from '../../action/handbook';
import Select from 'react-select';
import DateInput from '../utils/DateInput';
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';
import { roleId } from '../../constants/app';

class PopGoods extends Component {
    componentDidMount() {
       this.props.fetchCities();
    }

    setFilters = (field) => (data) => {
        const { filters } = this.props.orderGoods;
        const updated = {
            ...filters,
            [field]: data
        }
        this.props.setStatFilters('orderGoods', updated);
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props.orderGoods;

        const updated = {
            ...filters,
            [field]: date,
        };

        const isAfter = moment(updated.createdStartDate).isAfter(updated.createdEndDate)
        
        if (field === 'createdEndDate' && isAfter) {
            updated.createdStartDate = date
        }
        
        if (field === 'createdStartDate' && isAfter) {
            updated.createdEndDate = date
        }

        this.props.setStatFilters('orderGoods', updated);
    }

    onDownloadPopularGoods = () => {
        this.props.fetchPopularGoods()
        .then((res) => {
            if(!!res) {
                const clients = res.map(item => {
                    return {
                        'Id категории': item.categoryId ? item.categoryId : '-',
                        'Id товара': item.goodId ? item.goodId : '-',
                        'Название категории': item.category ? item.category : '-',
                        'Название товара': item.good 
                            ? item.modifications ? `${item.good} ${item.modifications}` : item.good
                            : '-',
                        'Количество товаров': item.count,
                    }
                })
                const ws = utils.json_to_sheet(clients);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Data");
                writeFileXLSX(wb, "OrderPopularGoods.xlsx");
            }
        });
    }

    onDownloadOrderGoods = () => {
        this.props.fetchOrderGoods()
        .then((res) => {
            if(!!res) {
                debugger;
                const clients = res.map(item => {
                    return {
                        ...item
                    }
                })
                const ws = utils.json_to_sheet(clients);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Data");
                writeFileXLSX(wb, "OrderAllGoods.xlsx");
            }
        });
    }

    isDisabled = () => {
        const { clients } = this.props
        const { filters } = clients;

        if (filters.createdStartDate && filters.createdEndDate) {
            return false;
        }
        return true;
    }

    getOptionsSelectCity() {
        const { user, cities } = this.props;
        let options = [];

        if (user.allPoints || user.role.id === roleId.admin) options.push({value: 'all', label: 'Все города'});
        cities.forEach(item => {
            options.push({value: item.id, label: item.name})
        });

        return options;
    }
    
    renderHead() {
        const { orderGoods } = this.props
        const { loading, filters } = orderGoods;

        return (
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Популярные товары
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div className="dateBlock">
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата от"
                            selected={filters.createdStartDate}
                            onChange={this.onChangeDateInput('createdStartDate')}
                            maxDate={moment().toDate()}
                        />
                        <div>-</div>
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата до"
                            selected={filters.createdEndDate}
                            onChange={this.onChangeDateInput('createdEndDate')}
                            maxDate={moment().toDate()}
                            required={filters.createdStartDate}
                        />
                    </div>
                    <div style={{ width: 250 }}>
                        <Select
                            isLoading={this.props.loadingCity || loading}
                            isDisabled={this.props.loadingCity || loading}
                            value={filters.city}
                            closeMenuOnSelect={true}
                            options={this.getOptionsSelectCity()}
                            onChange={this.setFilters('city')}
                            placeholder="Город"
                            noOptionsMessage={() => 'Нет городов'}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderBody() {
        const { orderGoods } = this.props
        const { filters } = orderGoods;
        if (!filters.city) 
            return (
                <div className="kt-portlet">
                    <div className="kt-portlet__body">Не указан город</div>
                </div>
            );

        return (
            <>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Популярные товары
                            </h3>
                            <span className='info_statistic-label' title="Скачать файл с товарами, которые заказывали клиенты в выбранном городе за указанный период, включающий в себя информацию о товаре, категории товара и кол-ве продаж этого товара">?</span>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div className="dateBlock" style={{ marginRight: 10 }}>
                                <button onClick={this.onDownloadPopularGoods} className="btn btn-dark btn-icon-sm">Экспорт</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Товары в заказах
                            </h3>
                            <span className='info_statistic-label' title="Скачать файл с товарами, которые заказывали клиенты в выбранном городе за указанный период, включающий в себя информацию о товаре (id, цена, кол-во в заказе, название) и заказе (номер заказа, город, дата и время)">?</span>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div className="dateBlock" style={{ marginRight: 10 }}>
                                <button onClick={this.onDownloadOrderGoods} className="btn btn-dark btn-icon-sm">Экспорт</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    render() {
        return (
            <div className="kt-portlet">
                {this.renderHead()}
                {this.renderBody()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ({
        orderGoods: state.statistics.orderGoods,
        cities: state.handbook.cities,
        loadingCity: state.loaders.cities,
        user: state.user.info,
    });
};

const mapDispatchToProps = {
    fetchCities: () => fetchCities(true),
    setStatFilters: (name, filters) => setStatFilters(name, filters),
    resetStatFilters: (name) => resetStatFilters(name),
    fetchPopularGoods: () => fetchPopularGoods(),
    fetchOrderGoods: () => fetchOrderGoods()
}

export default connect(mapStateToProps, mapDispatchToProps)(PopGoods);